import * as React from 'react';
import Modal from '../modal';
import Select from 'react-select';

interface BooleanSelectModalProps {
    header: string;
    show: boolean;
    options: Array<{ id: boolean, name: string }>
    value: Array<string | number | boolean>;
    onApply: (filter: string[]) => void;
    onClose: (event?: any) => void;
    onChange: (values: string[], event?: any) => void;
    onClear: (event?: any) => void;
}

export default class BooleanSelectModal extends React.Component<BooleanSelectModalProps> {
    render() {
        const { header, show, options, value, onClose, onChange, onApply, onClear } = this.props;
        const handleChange = (values: any, event?: any) => onChange([values["id"]], event);
        const handleClear = (event?: any) => {
            onChange([], event);
            onClear(event);
        };
        const handleApply = () => {
            if (value && value.length > 0) {
                const filterValue = value[0] === true ? ['true'] : ['false'];
                onApply(filterValue);
            } else {
                onApply([]);
            }
        };

        return <Modal show={show} closeModalHandler={onClose} header={header}>
            <div className='modal-body'>
                <div className='row'>
                    <div className='col-md-12 form-group'>
                        <label>Match</label>
                        <Select<{id: boolean, name: string}>
                            options={options}
                            classNamePrefix="multiSelect"
                            value={value ? options.find(o => o.id === value[0]) : null}
                            getOptionValue={o => o.id.toString()}
                            getOptionLabel={o => o.name}
                            isMulti={false}
                            onChange={handleChange} />
                    </div>
                </div>
            </div>
            <div className='modal-footer'>
                <button className='btn btn-primary' onClick={handleApply}>OK</button>
                <button className='btn btn-danger' onClick={handleClear}>Clear</button>
            </div>
        </Modal>
    }
}
